"use client";

import clsx from "clsx";
import type { ReactNode } from "react";

type Props = {
  label: ReactNode;
  name?: string;
  register?: any;
  error?: string;
  className?: string;
  disabled?: boolean;
};

export default function FormCheckbox({
  label,
  register,
  error,
  className,
  disabled = false,
}: Props) {
  return (
    <div className={clsx("flex flex-col", className)}>
      
      {/* checkbox + label */}
      <label className={clsx("flex items-center gap-2 cursor-pointer", disabled && "cursor-not-allowed opacity-50")}>
        <input
          type="checkbox"
          {...register}
          disabled={disabled}
          className="w-4 h-4 accent-primary cursor-pointer disabled:cursor-not-allowed"
        />

        <span className="text-foreground text-sm">
          {label}
        </span>
      </label>

      {/* error */}
      {error && (
        <p className="text-danger text-xs mt-1">
          {error}
        </p>
      )}
    </div>
  );
}